export default __webpack_public_path__ + "static/media/common_perfect.3e44da55.jpg";